import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  getData$(key: string): Observable<string> {
    return of(localStorage.getItem(key));
  }

  setData$(data: { [key: string]: string }): Observable<void[]> {
    return of(Object.keys(data).map((key: string) => localStorage.setItem(key, data[key])));
  }

  removeData$(keys: string[]): Observable<void[]> {
    return of(keys.map((key: string) => localStorage.removeItem(key)));
  }

  clearAllExceptSpecialKeys(keys: string[] = []): void {
    const storageSize = localStorage.length;
    const storageKeys = [];

    if (!Array.isArray(keys) || !storageSize) {
      return;
    }

    for (let i = 0; i < storageSize; i++) {
      storageKeys.push(localStorage.key(i));
    }

    storageKeys.forEach((key: string) => {
      if (!keys.includes(key)) {
        localStorage.removeItem(key);
      }
    });
  }
}
